export function initGalleryLightbox() {
   const photos = document.querySelector('.talent-photos');
   if (!photos) return;

   const images = [...photos.querySelectorAll('img')];
   if (!images.length) return;

   let current = 0;
   let slideDir = 0;

   // ── Build DOM ───────────────────────────────────────────────────────────────

   const lb = document.createElement('div');
   lb.className = 'gallery-lightbox';
   lb.setAttribute('aria-modal', 'true');
   lb.setAttribute('role', 'dialog');
   lb.innerHTML = `
      <div class="gallery-lightbox__backdrop"></div>
      <button class="gallery-lightbox__close" aria-label="Close">×</button>
      <button class="gallery-lightbox__prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="20"><path fill="currentColor" fill-rule="evenodd" d="M.366 19.708c.405.39 1.06.39 1.464 0l8.563-8.264a1.95 1.95 0 0 0 0-2.827L1.768.292A1.063 1.063 0 0 0 .314.282a.976.976 0 0 0-.011 1.425l7.894 7.617a.975.975 0 0 1 0 1.414L.366 18.295a.974.974 0 0 0 0 1.413"/></svg></button>
      <div class="gallery-lightbox__stage">
         <img class="gallery-lightbox__img" src="" alt="">
         <p class="gallery-lightbox__caption"></p>
      </div>
      <button class="gallery-lightbox__next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="20"><path fill="currentColor" fill-rule="evenodd" d="M.366 19.708c.405.39 1.06.39 1.464 0l8.563-8.264a1.95 1.95 0 0 0 0-2.827L1.768.292A1.063 1.063 0 0 0 .314.282a.976.976 0 0 0-.011 1.425l7.894 7.617a.975.975 0 0 1 0 1.414L.366 18.295a.974.974 0 0 0 0 1.413"/></svg></button>
      <div class="gallery-lightbox__counter"></div>
   `;
   document.body.appendChild(lb);

   const lbImg = lb.querySelector('.gallery-lightbox__img');
   const caption = lb.querySelector('.gallery-lightbox__caption');
   const counter = lb.querySelector('.gallery-lightbox__counter');

   // ── Helpers ─────────────────────────────────────────────────────────────────

   function getFullUrl(img) {
      const link = img.closest('a');
      return link ? link.href : img.src;
   }

   function show(index, dir = 0) {
      slideDir = dir;
      current = (index + images.length) % images.length;
      lbImg.classList.remove('is-loaded', 'anim-next', 'anim-prev');
      void lbImg.offsetWidth; // force reflow to restart animation
      lbImg.src = getFullUrl(images[current]);
      lbImg.alt = images[current].alt || '';
      caption.textContent = images[current].alt || '';
      caption.hidden = !images[current].alt;
      counter.textContent = `${current + 1} / ${images.length}`;
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
   }

   function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
   }

   // ── Image load fade ─────────────────────────────────────────────────────────

   lbImg.addEventListener('load', () => {
      if (slideDir !== 0) {
         lbImg.classList.add('is-loaded', slideDir > 0 ? 'anim-next' : 'anim-prev');
      } else {
         lbImg.classList.add('is-loaded');
      }
   });

   // ── Wire up gallery images ──────────────────────────────────────────────────

   images.forEach((img, i) => {
      const link = img.closest('a');
      if (link) {
         link.addEventListener('click', (e) => {
            e.preventDefault();
            show(i);
         });
      } else {
         img.style.cursor = 'pointer';
         img.addEventListener('click', () => show(i));
      }
   });

   // ── Controls ────────────────────────────────────────────────────────────────

   lb.querySelector('.gallery-lightbox__close').addEventListener('click', close);
   lb.querySelector('.gallery-lightbox__backdrop').addEventListener('click', close);
   lb.querySelector('.gallery-lightbox__prev').addEventListener('click', () => show(current - 1, -1));
   lb.querySelector('.gallery-lightbox__next').addEventListener('click', () => show(current + 1, 1));

   document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1, -1);
      if (e.key === 'ArrowRight') show(current + 1, 1);
   });

   // ── Touch swipe ─────────────────────────────────────────────────────────────

   let touchStartX = 0;

   lb.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
   }, { passive: true });

   lb.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 40) return;
      e.preventDefault(); // suppress the ghost click that would hit the backdrop
      show(dx < 0 ? current + 1 : current - 1, dx < 0 ? 1 : -1);
   });
}
